import { render, staticRenderFns } from "./ReportDisplay.vue?vue&type=template&id=10e9965c"
import script from "./ReportDisplay.vue?vue&type=script&lang=ts"
export * from "./ReportDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports